import historyIndex from "../books/history.json";
import kudamulukku2017Index from "../books/kudamulukku2017.json";


const booksConfig = {
  history: {
    title: "ஸ்ரீ பொன்னாச்சி அம்மன் வரலாறு",
    index: historyIndex,   // direct JSON object
    patternMode: false,
  },
  kudamulukku2017: {
    title: "பெரிய கோயில் குடமுழுக்கு நன்றிமடல்",
    index: kudamulukku2017Index,   // direct JSON object
    patternMode: false,
  },
};

export default booksConfig;
